import React, { PropsWithChildren } from 'react';
import { StyleSheetManager, withTheme, ThemeProvider } from 'styled-components';

import Frame from './styled-frame/Frame';
import { FrameContextConsumer } from './styled-frame/Context';

type IframeProps = PropsWithChildren<{
  bottomSpacing: number;
  sideSpacing: number;
  alignLeft: boolean;
  style?: React.CSSProperties;
  theme?: unknown;
  [key: string]: unknown;
}>;

// Mostly taken from https://github.com/hydrateio/react-styled-frame
export default withTheme(
  ({
    bottomSpacing,
    sideSpacing,
    alignLeft,
    children,
    style = {},
    theme,
    isMobile = false,
    isHidden = false,
    contentHeight = 0,
    ...rest
  }: IframeProps) => (
    <Frame
      style={{
        display: isHidden ? 'none' : 'block',
        overflow: isMobile ? 'none' : 'scroll',
        border: 0,
        position: isMobile ? 'static' : 'fixed',
        zIndex: '2147483000',
        height: isMobile && contentHeight ? `${contentHeight}px` : '100px',
        width: isMobile ? '100%' : '100px',
        bottom: `calc(${bottomSpacing}px - 26px)`,
        [alignLeft ? 'left' : 'right']: `calc(${sideSpacing}px - ${
          alignLeft ? '28px' : '15px'
        })`,
        ...style,
      }}
      {...rest}
    >
      <FrameContextConsumer>
        {(frameContext) => (
          <StyleSheetManager target={frameContext.document?.head}>
            {theme ? (
              <ThemeProvider theme={theme}>{children}</ThemeProvider>
            ) : (
              children
            )}
          </StyleSheetManager>
        )}
      </FrameContextConsumer>
    </Frame>
  ),
);
